import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getStudentAdjustments } from 'actions/additional_adjustments';
import { translate } from '@haldor/ui';
import { Collapsible } from 'UI';
import StudentAdjustment from 'containers/AdditionalAdjustments/Display/StudentAdjustment';
var AdditionalAdjustments = /*#__PURE__*/function (_Component) {
  function AdditionalAdjustments() {
    var _this;
    _classCallCheck(this, AdditionalAdjustments);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AdditionalAdjustments, [].concat(args));
    _defineProperty(_this, "componentDidMount", function () {
      _this.props.getStudentAdjustments(_this.props.activeStudent.id);
    });
    return _this;
  }
  _inherits(AdditionalAdjustments, _Component);
  return _createClass(AdditionalAdjustments, [{
    key: "render",
    value: function render() {
      var active = this.props.studentAdjustments.filter(function (adjustment) {
        return adjustment.status == 'ACTIVE';
      });
      var completed = this.props.studentAdjustments.filter(function (adjustment) {
        return adjustment.status == 'COMPLETED';
      });
      var translate = this.props.translate;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        className: "c--title"
      }, this.props.translate('Additional adjustments')), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }), active.map(function (adjustment) {
        return /*#__PURE__*/React.createElement(StudentAdjustment, {
          key: adjustment.id,
          adjustment: adjustment
        });
      }), completed.length > 0 ? /*#__PURE__*/React.createElement(Collapsible, {
        trigger: translate('Completed')
      }, completed.map(function (adjustment) {
        return /*#__PURE__*/React.createElement(StudentAdjustment, {
          key: adjustment.id,
          adjustment: adjustment
        });
      })) : null);
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    studentAdjustments: state.AdditionalAdjustments.studentAdjustments,
    activeStudent: state.User.activeStudent,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  getStudentAdjustments: getStudentAdjustments
})(AdditionalAdjustments);